import { render, staticRenderFns } from "./reportQuery.vue?vue&type=template&id=71824066&scoped=true"
import script from "./reportQuery.vue?vue&type=script&lang=js"
export * from "./reportQuery.vue?vue&type=script&lang=js"
import style0 from "./reportQuery.vue?vue&type=style&index=0&id=71824066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71824066",
  null
  
)

export default component.exports